<template>
    <div class="page-wrapper palette-generator-page">

        <user-card v-if="$parent.documentData.name" class="mt-4"></user-card>
        <canvas id="canvas"></canvas>

        <div class="colours-palette">
            <div class="">
                <router-link :to="{ name: 'Colour generator'}" class="close-icon">
                    <img src="/assets/colour-generator/images/close.svg">
                </router-link>
                <div class="updated-message-wrapper" v-if="successUpdateMessage">
                    <div class="updated-message" style="display: block;">
                        <p><img src="/assets/img/checkbox-outline.svg" alt="">{{ successUpdateMessage }}</p>
                    </div>
                </div>
                <div class="row">
                        <div :style="{ width: (100/newColours.length) + '%'}" v-for="(colour, $index) in newColours">
                            <div class="color" id="color1"
                                 v-bind:style="{ backgroundColor: colour}">
<!--                                <div class="copy-hex">-->
<!--                                    <span>Copy Hex</span>-->
<!--                                    <img src="/assets/colour-generator/images/check.svg" class="check" alt="check">-->
<!--                                </div>-->
                                <div class="hex-code text-uppercase" v-if="$index == Math.floor(newColours.length/2)">
                                    <span v-if="!baseLocked">{{ mainHex }}</span>
                                    <span v-else><input v-model="mainHex" @change="customBaseColour()" class="form-control" /></span>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div class="lock-icon" @click="lockColour()" :class="{ 'blue-bg': baseLocked }">
                <svg v-if="!baseLocked" xmlns="http://www.w3.org/2000/svg" width="18" height="24"><path d="M9.625 15.75v1.875a.938.938 0 01-1.875 0V15.75a.938.938 0 011.875 0zM3.062 12a.938.938 0 00-.937.938v7.5c0 .517.42.937.938.937h11.25c.517 0 .937-.42.937-.938v-7.5a.938.938 0 00-.938-.937zm14.063.938v7.5a2.812 2.812 0 01-2.813 2.812H3.063A2.812 2.812 0 01.25 20.437v-7.5a2.812 2.812 0 012.813-2.812v-3.75a5.626 5.626 0 0111.25 0v3.75a2.812 2.812 0 012.812 2.813zM8.687 2.624a3.75 3.75 0 00-3.75 3.75v3.75h7.5v-3.75a3.75 3.75 0 00-3.75-3.75z"/></svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="24"><path fill="#fff" d="M9.625 15.75v1.875a.938.938 0 01-1.875 0V15.75a.938.938 0 011.875 0zM3.062 12a.938.938 0 00-.937.938v7.5c0 .517.42.937.938.937h11.25c.517 0 .937-.42.937-.938v-7.5a.938.938 0 00-.938-.937zm14.063.938v7.5a2.812 2.812 0 01-2.813 2.812H3.063A2.812 2.812 0 01.25 20.437v-7.5a2.812 2.812 0 012.813-2.812v-3.75a5.626 5.626 0 0111.25 0v3.75a2.812 2.812 0 012.812 2.813zM8.687 2.624a3.75 3.75 0 00-3.75 3.75v3.75h7.5v-3.75a3.75 3.75 0 00-3.75-3.75z"/></svg>
            </div>

        </div>

        <div class="details">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-8">
                        <h2>Palette Generator</h2>
                        <p>Generate a new palette with the refresh button<br> or refine the hue of the bottom two rows
                            using the arrows.</p>

                        <div class="colors-palette">
                            <div class="colorbox" v-for="colour in newColours">
                                <div class="color"
                                     @click="copyToClipboard( colour)"
                                     v-bind:class="{ 'copied' : (copiedHex == colour) }"
                                     v-bind:style="{ backgroundColor: colour}"
                                     v-bind:data-clipboard-text="colour">
                                    <span class="copy-text">Copy</span>
                                    <span class="check-image">
                                    <img src="/assets/colour-generator/images/check.svg" class="check" alt="check">
                                </span>
                                </div>
                                <div class="hex-code text-uppercase">{{ colour }}</div>
                            </div>
                        </div>
                        <br/>
                        <div class="palette-generator-controls">
                            <div>
                                <p>Colour Gap: {{ rotateHue }} </p>
                                <range-slider
                                    class="slider"
                                    style="width: 250px;"
                                    min="15"
                                    max="360"
                                    step="5"
                                    v-model="rotateHue">
                                </range-slider>
                            </div>
                            <div class="hue-field">
                                <div class="refresh-icon" @click="resetColours()"><img src="/assets/colour-generator/images/refresh-icon.png"></div>
                            </div>
                            <div>
                                <p>Colours amount: {{ coloursCount }} </p>
                                <range-slider
                                    @change="updateColours(coloursCount)"
                                    class="slider"
                                    style="width: 250px;"
                                    min="3"
                                    max="9"
                                    step="1"
                                    v-model="coloursCount">
                                </range-slider>
                            </div>
                        </div>
                        <button @click="saveDocument()" v-if="!edit"
                                class="btn btn-outline-primary mt-4">SAVE THIS THEME
                        </button>

                        <button @click="updateDocument()" v-if="edit && !readOnly"
                                class="btn btn-outline-primary mt-4">{{  updateBtnText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import colorHueService from "../../services/colorHueService";
import Vue from 'vue';
import VueKonva from 'vue-konva'
import RangeSlider  from 'vue-range-slider';
import UserCard from "../partials/UserCard";

Vue.use(VueKonva)
export default {
    name: "ColourImage",
    props: [],
    components: {
        RangeSlider,
        UserCard
    },
    data: function () {
        return {
            mainHex: null,

            edit: false,
            readOnly: false,
            copiedHex: null,
            rotateHue: 90,
            coloursCount: 9,
            baseColourObj: null,
            secondColourObj: null,
            thirdColourObj: null,
            lightBackground: null,
            ctx: null,

            canvasWidth: 80,
            canvasHeight: 80,

            configKonva: {
                width: 200,
                height: 200
            },
            configRect: {
                x: 20,
                y: 40,
                width: 100,
                height: 100,
                fill: "red",
                strokeWidth: 4
            },

            allColours: [],
            newColours: [],

            baseLocked: false,
            baseColor: null,
            updateBtnText: 'UPDATE',
            successUpdateMessage: '',

            firstColour: null,
            secondColour: null,
            thirdColour: null,
        }
    },
    mounted() {

        if(this.$route.query.id) {
            this.edit = true;
            this.loadDocument()
        } else {
            let localData = localStorage.getItem('temp_app_data')
            if(localData) {
                localData = JSON.parse(localData);

                this.rotateHue = localData.entity_data.rotateHue;
                this.colours = localData.entity_data.colours;
                this.coloursCount = localData.entity_data.coloursAmount;

                this.newColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
                this.allColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone

                this.updateColours(this.coloursCount)

                this.readOnly = !this.$parent.checkIfIamAuthor();
                this.maxSliderValue = this.allColours.length;
                localStorage.removeItem('temp_app_data');
                // default colour
            } else {
                this.init();
            }
        }

        // clone
        if(this.$route.query.clone && this.newColours) {
            this.clone();
        }
    },
    watch: {
        rotateHue: {
            handler(val){
                // change palette hue and keep the primary
                this.resetColours(false);
            },
            deep: true
        }
    },
    methods: {

        //
        init: function (newPalette = true) {
            // set rotation based on input value
            this.rotateHue = parseInt(this.rotateHue, 10);
            this.canvas = document.getElementById('canvas');

            this.drawCanvas(newPalette);
            this.createPalette();

            //
            // when hue is changed or reload pressed,
            if(!newPalette) {
                this.updateColours(this.coloursCount)
            } else {
                this.coloursCount = this.colours.length;
                this.newColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
                this.allColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
            }


            // clone
            if(this.$route.query.clone && this.document) {
                this.clone();
            }
        },

        resetColours: function (newPalette = true) {
            // set rotation based on input value
            this.rotateHue = parseInt(this.rotateHue, 10);
            this.canvas = document.getElementById('canvas');

            this.drawCanvas(newPalette);
            this.createPalette();

            this.allColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
            this.updateColours(this.coloursCount);
        },

        customBaseColour(coloursCount = false) {
            this.drawCanvas(false, this.mainHex);
            this.createPalette(this.mainHex);

            if(!coloursCount) {
                this.coloursCount = this.colours.length;
            }
            this.newColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
            this.allColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
        },


        loadDocument() {
            this.$parent.loadDoc(this.$route.query.id).then(({data}) => {
                this.document = data.doc;
                this.rotateHue = data.entity.meta.rotateHue;
                this.colours = data.entity.meta.colours;
                this.coloursCount = data.entity.meta.coloursAmount;
                if(data.entity.meta.baseLocked) {
                    this.baseLocked = data.entity.meta.baseLocked;
                }


                if(!data.entity.meta.mainHex) {
                    let index = Math.ceil(data.entity.meta.coloursAmount/2)
                    this.mainHex = this.colours[index];
                } else {
                    this.mainHex = data.entity.meta.mainHex;
                }
                this.newColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone
                this.allColours = JSON.parse(JSON.stringify(this.colours)); // keep the clone


                this.readOnly = !this.$parent.checkIfIamAuthor();

                this.canvas = document.getElementById('canvas');
                this.firstColour =data.entity.meta.firstColour;
                this.secondColour =data.entity.meta.secondColour;
                this.thirdColour =data.entity.meta.thirdColour;

                this.mainHex = this.$helpers.HSLToHex(this.firstColour);
                this.paintColors(this.firstColour, this.secondColour, this.thirdColour);
                this.setColours(false);


                this.primaryPalette = this.getColor(this.canvasWidth / 2 + 10, 0 + 10);
                if(data.entity.meta.baseLocked) {
                    this.customBaseColour(this.coloursCount);
                }
                this.updateColours(this.coloursCount);
            });
        },

        saveDocument() {
            this.$parent.documentData.entity_data = {
                colours: this.colours,
                rotateHue: this.rotateHue,
                coloursAmount: this.coloursCount,
                mainHex: this.mainHex,
                baseLocked: this.baseLocked,
                firstColour: this.firstColour,
                secondColour: this.secondColour,
                thirdColour: this.thirdColour,
            }
            this.$parent.saveDoc();
        },
        updateDocument() {
            this.updateBtnText = 'UPDATING...';
            this.$parent.documentData.entity_data = {
                colours: this.colours,
                rotateHue: this.rotateHue,
                coloursAmount: this.coloursCount,
                mainHex: this.mainHex,
                baseLocked: this.baseLocked,
                firstColour: this.firstColour,
                secondColour: this.secondColour,
                thirdColour: this.thirdColour,
            }
            this.$parent.updateDoc(this.$route.query.id);
            setTimeout(() => {
                this.updateBtnText = 'UPDATE';
                this.successUpdateMessage = 'Document saved!';
                setTimeout(() => {
                    this.successUpdateMessage = '';
                }, 2000);
            }, 1000)
        },

        clone() {
            this.$parent.settingCloneTitle = true;
        },

        setColours: function (newPalette) {
            if(! this.firstColour || newPalette) {
                this.baseColourObj = new colorHueService();
            } else {
                let numbers = this.firstColour.match(/\(([^)]+)\)/)[1];
                let vars = numbers.split(",");
                let h = vars[0];
                let s = vars[1].substring(0, vars[1].length - 1);
                let l = vars[2].substring(0, vars[2].length - 1);
                this.baseColourObj = new colorHueService(h, s, l);
            }

            let hue = this.baseColourObj.changeHue(this.baseColourObj.getHue(), this.rotateHue);
            let saturation = this.baseColourObj.getSaturation();
            let light = this.baseColourObj.getLight();
            this.secondColourObj = new colorHueService(hue, saturation, light);

            let thirdHue = this.baseColourObj.changeHue(this.baseColourObj.hue, this.rotateHue + this.rotateHue);
            this.thirdColourObj = new colorHueService(thirdHue, saturation, light);
        },
        drawCanvas: function (newPalette, customHex) {
            if(this.baseLocked) {
                newPalette = false;
            }
            this.setColours(newPalette);
            if(!customHex) {
                this.firstColour = this.baseColourObj.getHSL();
            } else {
                this.firstColour = this.$helpers.hexToHSL(customHex);
                this.baseColor = this.$helpers.hexToHSL(customHex);
            }

            this.secondColour = this.secondColourObj.getHSL();
            this.thirdColour = this.thirdColourObj.getHSL();
            // Top color
            if(this.baseColor && this.baseLocked) {
                this.firstColour = this.baseColor;
            }

            this.mainHex = this.$helpers.HSLToHex(this.firstColour);
            this.paintColors(this.firstColour, this.secondColour, this.thirdColour);
        },
        paintColors(firstColour, secondColour, thirdColour) {
            this.drawColor(0, 0, this.canvasWidth, this.canvasHeight, firstColour);
            this.drawColor(0, this.canvasHeight / 3, this.canvasWidth, this.canvasHeight, secondColour);
            // Bottom color
            this.drawColor(0, this.canvasHeight / 3 + this.canvasHeight / 3, this.canvasWidth, this.canvasHeight, thirdColour);


            // Left color overlay (lightens with yellow)
            this.drawColor(0, 0, this.canvasWidth / 3, this.canvasHeight, '#fcd108', 'screen', 0.75);
            // Right color overlay (darkens with blue)
            this.drawColor(this.canvasWidth / 3 + this.canvasWidth / 3, 0, this.canvasWidth / 3, this.canvasHeight, '#094078', 'overlay');
            // Full color overlays (creates a cast over all colors for a more uniform, moderated look)
            this.drawColor(0, 0, this.canvasWidth, this.canvasHeight, '#ffcc00', 'overlay', 0.25);
            this.drawColor(0, 0, this.canvasWidth, this.canvasHeight, '#f13a6d', 'lighten', 0.25);
            this.drawColor(0, 0, this.canvasWidth, this.canvasHeight, '#092559', 'screen', 0.5);
        },
        createPalette: function (customHex) {
            let primaryPalette;
            if(! this.baseLocked || customHex) {
                this.primaryPalette = this.getColor(this.canvasWidth / 2 + 10, 0 + 10);
            }


            // let primaryPalette = this.getColor(this.canvasWidth / 2 + 10, 0 + 10);
            let colours = [
                this.getColor(10, this.canvasHeight / 2 + 10),
                this.getColor(this.canvasWidth / 2 + 10, this.canvasHeight / 2 + 10),
                this.getColor(this.canvasWidth - 10, this.canvasHeight / 2 + 10),

                // keep them at the middle
                this.getColor(10, 10),
                // this.getColor(this.canvasWidth / 2 + 10, 0 + 10), // primary colour
                this.primaryPalette,
                this.getColor(this.canvasWidth - 10, 10),

                this.getColor(10, this.canvasHeight - 10),
                this.getColor(this.canvasWidth / 2 + 10, this.canvasHeight - 10),
                this.getColor(this.canvasWidth - 10, this.canvasHeight - 10)
            ];
            this.colours = [];
            for (let i = 0; i < colours.length; i++) {
                this.colours.push(this.$helpers.rgbToHex(colours[i]));
            }
        },

        getColor(x, y) {
            let rgba = this.ctx.getImageData(x, y, 1, 1).data;
            rgba[3] = 1; // set alpha channel from 255 to 1

            return rgba;
        },

        drawColor: function (x, y, width, height, color, blendMode, alpha) {
            this.ctx = this.canvas.getContext('2d');
            this.ctx.width = width;
            this.ctx.height = height;
            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.fillStyle = color;
            this.ctx.globalAlpha = alpha || 1;
            this.ctx.globalCompositeOperation = blendMode || 'source-over';
            this.ctx.rect(x, y, width, height);
            this.ctx.fill();
            this.ctx.closePath();
            this.ctx.restore();
        },

        // Copy to clipboard
        copyToClipboard: function (colourHex) {
            this.$copyText(colourHex).then((e) => {
                this.copiedHex = colourHex;

                // reset to normal after 2 seconds
                setTimeout(() => {
                    this.copiedHex = null;
                }, 2000)
            })
        },

        //
        lockColour: function () {
            if(!this.baseLocked) {
                this.baseLocked = true;
                this.baseColor = this.baseColourObj.getHSL();
            } else {
                this.baseLocked = false;
            }

            this.customBaseColour();
        },

        //
        updateColours: function (newVal) {
            // let newVal = this.sliderValue;
            let startPosition = (newVal - this.allColours.length);
            let delCount = (this.allColours.length - newVal);
            let newSet = JSON.parse(JSON.stringify(this.allColours)); // clone

            let rDelCount, lDelCount;
            if(delCount > 1) {
                rDelCount = Math.floor(delCount/2);
                lDelCount = Math.ceil(delCount/2);

                newSet.splice(0, lDelCount);
                newSet.splice(startPosition, rDelCount);
            } else {
                newSet.splice(startPosition, delCount);
            }
            this.newColours = newSet;
        }
    }
}
</script>

<style scoped>

</style>
